import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { getFiveYearPerformance } from '../utils/assetPerformance';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const AssetPerformanceChart = ({ assetType, assetName }) => {
  const performanceData = getFiveYearPerformance(assetType);
  
  const chartData = {
    labels: performanceData.map(point => 
      point.date.toLocaleDateString('en-IN', { month: 'short', year: '2-digit' })
    ),
    datasets: [{
      label: assetName,
      data: performanceData.map(point => point.value),
      borderColor: getAssetColor(assetType),
      backgroundColor: `${getAssetColor(assetType)}20`,
      tension: 0.4,
      fill: true,
      pointRadius: 0,
      pointHoverRadius: 4,
      borderWidth: 2
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        mode: 'index',
        intersect: false,
        callbacks: {
          label: (context) => {
            const value = context.parsed.y;
            const returnPct = ((value - 100) / 100 * 100).toFixed(2);
            return `${returnPct}% return`;
          }
        }
      }
    },
    scales: {
      x: {
        display: true,
        grid: { display: false },
        ticks: { maxTicksLimit: 6 }
      },
      y: {
        display: true,
        grid: { color: '#f0f0f0' },
        ticks: {
          callback: (value) => `${((value - 100)).toFixed(0)}%`
        }
      }
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    }
  };

  return (
    <div className="h-48">
      <Line data={chartData} options={options} />
    </div>
  );
};

const getAssetColor = (assetType) => {
  const colors = {
    stocks: '#EF4444',
    mutualFunds: '#3B82F6',
    gold: '#F59E0B',
    fixedDeposit: '#10B981'
  };
  return colors[assetType] || '#6B7280';
};

export default AssetPerformanceChart;